import { ALE_KF_2026 } from '@val/engine'

/** Vårt parti – lyfts fram i vyer och simuleringar. Kan bytas i UI:t. */
export const DEFAULT_HIGHLIGHT_PARTY = 'C'

export const HIGHLIGHT_STORAGE_KEY = 'val.highlightParty'

export function getHighlightParty(): string {
  try {
    return localStorage.getItem(HIGHLIGHT_STORAGE_KEY) ?? DEFAULT_HIGHLIGHT_PARTY
  } catch {
    return DEFAULT_HIGHLIGHT_PARTY
  }
}

export function setHighlightParty(code: string): void {
  try {
    localStorage.setItem(HIGHLIGHT_STORAGE_KEY, code)
  } catch {
    /* ignorera */
  }
}

/** Mandat- och spärrparametrar för Ale KF 2026. */
export const ALE = ALE_KF_2026

/** Bygger AllocationOptions med korrekt hantering av valfri röstbas. */
export function aleOpts(totalValidVotes?: number) {
  return totalValidVotes && totalValidVotes > 0
    ? { ...ALE_KF_2026, totalValidVotes }
    : { ...ALE_KF_2026 }
}

export const ALE_MAJORITY = Math.floor(ALE_KF_2026.seats / 2) + 1

/** Poll-intervall i Live-vyn (ms). */
export const POLL_INTERVAL_MS = 45_000

/** Sätt VITE_USE_MOCK=0 för att alltid gå mot riktig /api även i dev. */
export const USE_MOCK_FALLBACK = import.meta.env.VITE_USE_MOCK !== '0'
